export default __webpack_public_path__ + "static/media/251.b81a186d.jpg";